import React, { useState, useEffect } from 'react';
import { Autocomplete, TextField, Chip } from '@mui/material';
import { getTags } from '../../services/tags';
import { Tag } from '../../types';

interface TagPickerProps {
  selectedTagIds: string[];
  onChange: (newTagIds: string[]) => void;
  label?: string;
  placeholder?: string;
}

const TagPicker: React.FC<TagPickerProps> = ({
  selectedTagIds,
  onChange,
  label = 'Tags',
  placeholder = 'Select tags'
}) => {
  const [tags, setTags] = useState<Tag[]>([]);

  useEffect(() => {
    fetchTags();
  }, []);

  const fetchTags = async () => {
    try {
      const fetchedTags = await getTags();
      setTags(fetchedTags);
    } catch (error) {
      console.error('Error fetching tags:', error);
    }
  };

  const selectedTags = tags.filter(tag => selectedTagIds.includes(tag._id));

  return (
    <Autocomplete
      multiple
      id="tags"
      options={tags}
      value={selectedTags}
      onChange={(event, newValue) => onChange(newValue.map(tag => tag._id))}
      getOptionLabel={(option) => option.name}
      isOptionEqualToValue={(option, value) => option._id === value._id}
      renderInput={(params) => (
        <TextField
          {...params}
          variant="standard"
          label={label}
          placeholder={placeholder}
        />
      )}
      renderTags={(value: Tag[], getTagProps) =>
        value.map((option: Tag, index: number) => (
          <Chip
            variant="outlined"
            label={option.name}
            {...getTagProps({ index })}
          />
        ))
      }
    />
  );
};

export default TagPicker;
